import { ContainerType, TaskConfigType } from 'Types/Tasks.types'
import { Dispatch, SetStateAction } from 'react'

export enum ConversationSenderType {
    USER = 'user',
    BOT = 'bot',
    DIVIDER = 'divider',
}

export type ConversationMessageType = {
    sender: ConversationSenderType
    message: string
}

export type AIAssistanceBodyType = {
    contextId: string
    taskConfig: TaskConfigType<ContainerType, unknown>
    input: string
    updateInput: Dispatch<SetStateAction<string>>
    conversations: ConversationMessageType[]
    onSubmitButton: () => Promise<void>
}

export enum RoleType {
    user = 'user',
    assistant = 'assistant',
}

export type AIAssistanceAPIPayloadType = {
    taskId: string
    taskPluginId: string
    contextId: string
    content: string
}

type MessageType = {
    role: RoleType
    content: string
}

export type AIAssistanceAPIResponseType = {
    taskId: string
    contextId: string
    messages: MessageType[]
}
